export type ExteriorFinishType = 'paint' | 'wrap' | 'ppf';

export interface ExteriorFinishData {
  color?: string | null;
  exterior_finish_type?: ExteriorFinishType | null;
  exterior_finish_color?: string | null;
  exterior_finish_brand?: string | null;
  exterior_finish_style?: string | null;
  exterior_finish_label?: string | null;
}

export const EXTERIOR_FINISH_TYPE_OPTIONS: { value: ExteriorFinishType; label: string; description: string }[] = [
  { value: 'paint', label: 'Factory paint', description: 'Stock or repainted (no wrap or PPF)' },
  { value: 'wrap', label: 'Vinyl wrap', description: 'Full or partial vinyl wrap over the base color' },
  { value: 'ppf', label: 'PPF', description: 'Paint protection film: clear, stealth, or colored' },
];

export const EXTERIOR_FINISH_STYLE_OPTIONS = [
  'Gloss',
  'Satin',
  'Matte',
  'Stealth',
  'Color-shift',
  'Chrome',
  'Textured',
] as const;

export const EXTERIOR_FINISH_BRAND_OPTIONS = [
  '3M',
  'Avery Dennison',
  'XPEL',
  'KPMF',
  'Teckwrap',
  'Inozetek',
  'Hexis',
  'Other',
] as const;

export const POPULAR_VEHICLE_COLORS = [
  'Alpine White',
  'Black',
  'Blue',
  'Gray',
  'Green',
  'Orange',
  'Pearl White',
  'Red',
  'Silver',
  'Yellow',
] as const;
